<p-table [value]="allShippingTerms" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Is Active</th>
            <th>Is Default</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-term>
        <tr>
            <td>{{term.name}}</td>
            <td>{{term.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
            <td>
                <p-radioButton [disabled]="term.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="term.isDefault"
                  (onClick)="shippingTermDefault(term)"></p-radioButton>
                {{term.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
              </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i class="pi
            pi-pencil" (click)="showEditShippingTerm(term)"></i></span>
                <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="!term.isDefault" (click)="checkDeleteStatus(term)"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{addEditShippingTermHeader}}" [(visible)]="displayShippingTermAdd" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}" (onHide)="shippingTermForm.reset()">
    <form [formGroup]="shippingTermForm">
        <div class="header">
            <h5>Shipping Term Information
                <p-inputSwitch class="header-switch" [disabled]="statusDisabled" formControlName="statusId"
                (onChange)="checkShippingTermStatus()"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>Shipping Term Name</label>
                    <input pInputText type="text" id="stName" name="stName" formControlName="name" />
                    <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayShippingTermAdd=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton [disabled]="!shippingTermForm.valid" (click)="saveShippingTerm(shippingTermForm.value)" label="Save"></button>
    </p-footer>
</p-dialog>